import React, {Component} from 'react'
import {Table} from 'reactstrap'
import PropTypes from 'prop-types'
import ProjectInvoicingTableRow from "./ProjectInvoicingTableRow";

export default class ProjectInvoicingTable extends Component {

    render() {

        const {data, onSelected} = this.props


        return (
            <Table style={{fontSize: '14px'}}>
                <thead>
                <tr>
                    <th>Project ID</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Total Budget</th>
                    <th>Expenditure (Gravity)</th>
                    <th>Expenditure (Suppliers)</th>
                    <th>Budget Remaining</th>
                    <th>Total Invoiced</th>
                    <th>Total Written Off</th>
                    <th>New Invoice Amount(s)</th>
                    <th>&nbsp;</th>
                </tr>
                </thead>

                <tbody>
                {data && data.map(project => <ProjectInvoicingTableRow
                                        key={project.project_id}
                                        {...project}
                                        onSelected={onSelected}
                                        />)}
                </tbody>

            </Table>
        )

    }

}

ProjectInvoicingTable.propTypes = {
    data: PropTypes.array.isRequired,
    onSelected: PropTypes.func.isRequired
}